import { Config } from "./Configuration";

const localhost: Config = {
    language: "en",
};

export default localhost;
